import React, {Component, Fragment} from 'react';
import "../../../Common/ResponsiveCart.css";
import CartRow from "../CartRow/CartRow";
import InitialQuotationState from "../../QuotationForm/InitialQuotationState";
import ReactImageZoom from "react-image-zoom";
import {FormattedMessage} from "react-intl";
import NumberFormatter from "../../../Common/NumberFormatter/NumberFormatter";
import CartItemDelete from "../CartItemDelete/CartItemDelete";
import edit_cart from "../../../../assets/img/edit_cart.png";
import CartPrint from "../CartPrint/CartPrint";
import {Link} from 'react-router-dom';
import CartItemDetailsExpandView from "../CartItem/CartItemDetails/CartItemDetailsExpandView";
import OrderType1ExpandedView from "../CartItem/CartItemDetails/OrderType1ExpandedView/OrderType1ExpandedView";
import OrderType3ExpandedView from "../CartItem/CartItemDetails/OrderType3ExpandedView/OrderType3ExpandedView";
import canvasDown from "../../../../assets/img/canvasdown.png";
import canvasUp from "../../../../assets/img/canvasup.png";
import CartChangeQty from "../CartChangeQty/CartChangeQty";
import CartItemMobileView from './CartItemMobileView'
import PriceLoadingImage from "../../../../assets/img/loading_price.gif";
import CartPagination from "../CartPagination";

// const ItemDetailsExpandView = (props) => {
//     if (props.showMore) {
//         let pcbParams = props.itemDetails.quotation.pcbParam;
//         if (props.itemDetails.quotation.orderType === 1) {
//             return (
//                 <OrderType1ExpandedView
//                     pcbParams={pcbParams}
//                     itemDetails={props.itemDetails}/>
//             )
//         } else if (props.itemDetails.quotation.orderType === 2) {
//             return (
//                 <div>
//                     <OrderType1ExpandedView
//                         pcbParams={pcbParams}
//                         itemDetails={props.itemDetails}/>
//                     <OrderType3ExpandedView
//                         smtStencilParams={props.itemDetails.quotation.stencilParam}
//                         itemDetails={props.itemDetails}/>
//                 </div>
//             )
//         } else if (props.itemDetails.quotation.orderType === 3) {
//             return (
//                 <OrderType3ExpandedView
//                     smtStencilParams={props.itemDetails.quotation.stencilParam}
//                     itemDetails={props.itemDetails}/>
//             )
//         }
//
//
//     }
//     return null;
// };


const ImageView = (props) => {
    if (props.imagePath) {
        const imgProps = {
            "width": 120, "scale": 2.75, "img": props.imagePath, "offset": {"vertical": -150, "horizontal": 10},
            "border": "1px solid #ececec"
        };
        return (
            <div className="cart-item-preview-image">
                <ReactImageZoom className="cart-item-preview-image" {...imgProps}/>
            </div>);
    } else {
        return <span>X</span>
    }
};

class CartMobileView extends Component {
    constructor(props) {
        super(props);

        this.setEditMode = this.setEditMode.bind(this);
    }

    setEditMode = () => {
        InitialQuotationState.cartItemEditMode = true;
    };

    componentDidMount() {
        let coll = document.getElementsByClassName("collapsible");
        let i;

        for (i = 0; i < coll.length; i++) {
            coll[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var content = this.nextElementSibling;
                if (content.style.maxHeight) {
                    content.style.maxHeight = null;
                } else {
                    content.style.maxHeight = content.scrollHeight + "px";
                }
            });
        }
    }

    render() {
        let allChecked = this.props.allChecked;
        let i = this.props.counter;
        return (
            <Fragment>
                <div>
                    {
                        this.props.cartItems.length !== 0 ?
                            <Fragment>
                                <input type="checkbox" checked={allChecked}
                                       onChange={this.props.toggleAllItems}/>&nbsp;
                                <label>
                                    すべてのアイテムを選択
                                </label>
                            </Fragment>
                            :
                            this.props.isGettingCartItems ?

                                    <div className="text-center">
                                        <br/>
                                        <h6>お待ちください。ページ{this.props.activePage}のアイテムを取得しています...</h6>
                                        <img className="loading-image-cart-items" width={70} src={PriceLoadingImage} alt="お待ちください。カートアイテムの取得..."/><br/><br/>
                                    </div>

                                    :<p className="responsive-no-cart-text">
                                        カートに商品がありません
                                    </p>

                            }


                </div>
                {this.props.cartItems.map(item => {
                    // const goTo = {
                    //     pathname: '/gerber_viewer',
                    //     imageUrl: item.gerberViewerUrl,
                    //     fileUrl: item.itemName
                    // };
                    // let checked = this.props.checkedItems.includes(item.id);

                    i++;
                    let buildTime = "";

                    return (
                        <CartItemMobileView
                            item={item}
                            itemData={this.props}
                            i={i}
                            checkedItems={this.props.checkedItems}
                            onCartItemDeleted = {this.props.onCartItemDeleted}
                            reviewResult = {item.reviewResult}
                        />

                    )


                })}

                <div>
                    <CartPagination
                        activePage={this.props.activePage}
                        itemsCountPerPage={this.props.itemsCountPerPage}
                        totalItemsCount={this.props.totalItemsCount}
                        handlePageChange={this.props.handlePageChange}
                    />
                </div>

            </Fragment>
        );
    }
}

export default CartMobileView;



// WEBPACK FOOTER //
// ./src/components/Site/Cart/CartMobileView/CartMobileView.js